import axios, { AxiosRequestConfig } from 'axios'
import { getSessionStorage, keyNameSessionStorage, removeSessionStorage, setSessionStorage } from './sessionStorage'
import { pathNames } from '../routers/router'
import apiUrl from '../configs/apiUrl'
import jwt from 'jsonwebtoken'
import useModal from '../hooks/useModal'
import { removeCmsToken, removeSelfToken } from './cookie'

export enum ErrorType {
    SERVER_ERROR = 500, // database error
    INPUT_INVALID = 400, // paramter ไม่ครบ หรือ ผิด
    NOT_ALLOWED = 301,
    NOT_FOUND = 404, // ไม่พบ
    UNAUTHORIZED = 401, // ไม่มีพบ user
    FORBIDDEN = 403, // ไม่สิทธิ์เข้าถึงระบบ
    NOT_ACCEPTABLE = 406, // ไม่สิทธิ์เข้าถึงระบบ
    EXPECTATION_FAILED = 417,
}

type AuthorizationType = 'authorization' | 'unauthorized' | undefined
type ContentType = 'proxy' | string

const axiosBasic = axios.create()
const axiosApiNotRefreshToken = axios.create()
const axiosApiInstance = axios.create()
const CancelToken = axios.CancelToken

// custom สำหรับ Auth0
axiosApiNotRefreshToken.interceptors.request.use(
    async (config) => {
        const accessToken = getSessionStorage(keyNameSessionStorage.accessToken)
        config.headers = {
            Authorization: `Bearer ${accessToken}`,
            // Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        }
        return config
    },
    (error) => {
        Promise.reject(error)
    },
)

// custom สำหรับ Auth0
axiosApiInstance.interceptors.request.use(
    async (config) => {
        const accessToken = getSessionStorage(keyNameSessionStorage.accessToken)
        config.headers = {
            Authorization: `Bearer ${accessToken}`,
            // Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        }
        return config
    },
    (error) => {
        Promise.reject(error)
    },
)

// custom สำหรับ Auth0
axiosApiInstance.interceptors.response.use(
    (response) => {
        return response
    },
    async function (error) {
        const Modal = useModal()
        const originalRequest = error.config

        const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken)
        const decoded = jwt.decode(refreshToken as string, { complete: true })

        if (error.response.status === ErrorType.UNAUTHORIZED && !originalRequest._retry) {
            try {
                originalRequest._retry = true
                // const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken)
                // const decoded = jwt.decode(refreshToken as string, { complete: true })

                //@ts-ignore
                if (decoded?.payload?.roles?.[0] === 'USER') {
                    const access_token = await refreshAccessToken(refreshToken)
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
                }

                //@ts-ignore
                if (decoded?.payload?.roles?.[0] === 'ADMIN') {
                    const access_token = await refreshAccessTokenAdmin(refreshToken)
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
                }

                return axiosApiInstance(originalRequest)
            } catch (error) {
                // ถ้า refesh token หมดอายุ
                Modal.error({
                    errorMessage:
                        'ไม่ได้ทำรายการในเวลาที่กำหนด เพื่อความความปลอดภัยในการทำรายกรุณาเข้าสู่ระบบใหม่อีกครั้ง',
                    modalProps: {
                        onOk: () => {
                            //@ts-ignore
                            if (decoded?.payload?.roles[0] === 'USER') {
                                removeSessionStorage([
                                    keyNameSessionStorage.user,
                                    keyNameSessionStorage.accessToken,
                                    keyNameSessionStorage.refreshToken,
                                ])
                                removeSelfToken()
                                removeCmsToken()

                                if (window.location.href !== process.env.PUBLIC_URL + pathNames.signIn) {
                                    window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                                }
                                //@ts-ignore
                            } else if (decoded?.payload?.roles[0] === 'ADMIN') {
                                removeSessionStorage([
                                    keyNameSessionStorage.user,
                                    keyNameSessionStorage.accessToken,
                                    keyNameSessionStorage.refreshToken,
                                ])
                                removeSelfToken()
                                removeCmsToken()

                                window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
                            } else {
                                removeSessionStorage([
                                    keyNameSessionStorage.user,
                                    keyNameSessionStorage.accessToken,
                                    keyNameSessionStorage.refreshToken,
                                ])
                                removeSelfToken()
                                removeCmsToken()

                                window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                            }
                        },
                    },
                })
            }
        }

        if (error.response.status === ErrorType.FORBIDDEN) {
            Modal.error({
                errorMessage: 'ไม่มีสิทธิ์เข้าถึงระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
                modalProps: {
                    onOk: () => {
                        // if (decoded?.payload?.roles[0] === 'ADMIN') {
                        //     window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
                        // }
                        //@ts-ignore
                        if (decoded?.payload?.roles[0] === 'USER') {
                            removeSessionStorage([
                                keyNameSessionStorage.user,
                                keyNameSessionStorage.accessToken,
                                keyNameSessionStorage.refreshToken,
                            ])
                            removeSelfToken()
                            removeCmsToken()

                            if (window.location.href !== process.env.PUBLIC_URL + pathNames.signIn) {
                                window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                            }
                            //@ts-ignore
                        } else if (decoded?.payload?.roles[0] === 'ADMIN') {
                            removeSessionStorage([
                                keyNameSessionStorage.user,
                                keyNameSessionStorage.accessToken,
                                keyNameSessionStorage.refreshToken,
                            ])
                            removeSelfToken()
                            removeCmsToken()

                            window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
                        } else {
                            removeSessionStorage([
                                keyNameSessionStorage.user,
                                keyNameSessionStorage.accessToken,
                                keyNameSessionStorage.refreshToken,
                            ])
                            removeSelfToken()
                            removeCmsToken()

                            window.location.href = process.env.PUBLIC_URL + pathNames.signIn
                        }
                    },
                },
            })
        }

        if (
            error.response.status === ErrorType.SERVER_ERROR ||
            error.response.status === ErrorType.INPUT_INVALID ||
            error.response.status === ErrorType.NOT_ALLOWED
        ) {
            Modal.error({})
        }
        if (
            error.response.status === ErrorType.NOT_ACCEPTABLE ||
            error.response.status === ErrorType.EXPECTATION_FAILED
        ) {
            return { data: { statusCode: error.response.status, message: error.response.data.error } }
        }

        return Promise.reject(error)
    },
)

// custom แบบธรรมดา
axiosBasic.interceptors.response.use(
    (response) => {
        return response
    },
    async function (error) {
        const Modal = useModal()

        if (
            error.response.status === ErrorType.SERVER_ERROR ||
            error.response.status === ErrorType.INPUT_INVALID ||
            error.response.status === ErrorType.NOT_ALLOWED
        ) {
            Modal.error({})
        }

        return Promise.reject(error)
    },
)

const getHeaders = (contentType?: string) => {
    switch (contentType) {
        case 'proxy':
            return { 'Content-Type': 'text/plain;charset=UTF-8' }
        default:
            return { 'Content-Type': 'application/json; charset=utf-8' }
    }
}

export const isExpired = () => {
    // get the decoded payload and header
    const now = Date.now()
    const token = getSessionStorage(keyNameSessionStorage.accessToken)

    if (token) {
        const decoded = jwt.decode(token, { complete: true })
        // @ts-ignore
        if ((decoded?.payload?.exp as number) < now) return true

        // // Find the timestamp for the end of the token's grace period
        // const threeHoursInMs = 3 * 60 * 60 * 1000
        // const threeHoursAfterExpiration = decoded.payload.exp + threeHoursInMs

        // if (threeHoursAfterExpiration > now) return 'grace'

        // return 'expired'
    }
}

const getAxios = (authorizationType: AuthorizationType) => {
    switch (authorizationType) {
        case 'authorization':
            // if (isExpired()) return axiosApiInstance
            // return axiosApiNotRefreshToken
            return axiosApiInstance
        case 'unauthorized':
            return axiosBasic
        default:
            return axiosBasic
    }
}

export const axiosGet = <Response = any, Parameter = any>({
    url,
    config,
    contentType,
    params,
    authorizationType = 'unauthorized',
}: {
    url: string
    config?: AxiosRequestConfig
    contentType?: ContentType
    params?: Parameter
    authorizationType?: AuthorizationType
}) => {
    let cancel
    const request = getAxios(authorizationType).get<Response>(url, {
        cancelToken: new CancelToken((c) => {
            cancel = c
        }),
        headers: getHeaders(contentType),
        data: params,
        ...config,
    })

    return { request, cancel }
}

export const axiosPost = <Response = any, Parameter = any>({
    url,
    config,
    params,
    contentType,
    authorizationType = 'unauthorized',
}: {
    url: string
    params: Parameter
    config?: AxiosRequestConfig
    contentType?: ContentType
    authorizationType?: AuthorizationType
}) => {
    let cancel
    const request = getAxios(authorizationType).post<Response>(url, params, {
        cancelToken: new CancelToken((c) => {
            cancel = c
        }),
        headers: getHeaders(contentType),
        ...config,
    })

    return { request, cancel }
}

export const axiosPut = <Response = any, Parameter = any>({
    url,
    config,
    params,
    contentType,
    authorizationType = 'unauthorized',
}: {
    url: string
    params: Parameter
    config?: AxiosRequestConfig
    contentType?: ContentType
    authorizationType?: AuthorizationType
}) => {
    let cancel
    const request = axiosApiInstance.put<Response>(url, params, {
        cancelToken: new CancelToken((c) => {
            cancel = c
        }),
        headers: getHeaders(contentType),
        ...config,
    })

    return { request, cancel }
}

export const axiosDelete = <Response = any>({
    url,
    config,
    contentType,
    authorizationType = 'unauthorized',
}: {
    url: string
    config?: AxiosRequestConfig
    contentType?: ContentType
    authorizationType?: AuthorizationType
}) => {
    let cancel
    const request = getAxios(authorizationType).delete<Response>(url, {
        cancelToken: new CancelToken((c) => {
            cancel = c
        }),
        headers: getHeaders(contentType),
        ...config,
    })

    return { request, cancel }
}

export const refreshAccessToken = async (refreshToken: string | null) => {
    // const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken)
    if (refreshToken) {
        const newToken = axiosPost<
            {
                accessToken: string
                refreshToken: string
            },
            { refreshToken: string }
        >({
            url: apiUrl.getNewToken,
            params: {
                refreshToken: refreshToken,
            },
        })
        const response = await newToken.request
        if (response.data && response.data.refreshToken && response.data.accessToken) {
            setSessionStorage(keyNameSessionStorage.accessToken, response.data.accessToken)
            setSessionStorage(keyNameSessionStorage.refreshToken, response.data.refreshToken)
        }
    }
}

export const refreshAccessTokenAdmin = async (refreshToken: string | null) => {
    // const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken)
    if (refreshToken) {
        const newToken = axiosPost<
            {
                accessToken: string
                refreshToken: string
            },
            { refreshToken: string }
        >({
            url: apiUrl.getNewTokenAdmin,
            params: {
                refreshToken: refreshToken,
            },
        })
        const response = await newToken.request
        if (response.data && response.data.refreshToken && response.data.accessToken) {
            setSessionStorage(keyNameSessionStorage.accessToken, response.data.accessToken)
            setSessionStorage(keyNameSessionStorage.refreshToken, response.data.refreshToken)
        }
    }
}

export const refreshAccessTokenSelf = async (refreshToken: string | null) => {
    // const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken)
    if (refreshToken) {
        const newToken = axiosPost<
            {
                accessToken: string
                refreshToken: string
            },
            { refreshToken: string }
        >({
            url: apiUrl.getNewTokenSelf,
            params: {
                refreshToken: refreshToken,
            },
        })
        const response = await newToken.request
        if (response.data && response.data.refreshToken && response.data.accessToken) {
            setSessionStorage(keyNameSessionStorage.accessToken, response.data.accessToken)
            setSessionStorage(keyNameSessionStorage.refreshToken, response.data.refreshToken)
        }
    }
}
